module.exports = __webpack_public_path__ + "static/media/icon-info-blue.1e31c0f9.svg";